<header class="fms-walk-me-header">
  <div class="fms-walk-me-row" style="gap: 10px">
    <div class="fms-walk-me-cap-icon">
      <svg-icon-sprite
        width="24px"
        height="28px"
        src="icon-progress-bar"
        vngTooltip="Onboarding"
        vngTooltipPosition="top"
      ></svg-icon-sprite>
    </div>
    <h3>Getting Started</h3>
    <button
      *ngIf="requiredComplete"
      vng-icon-button
      small
      color="none"
      type="button"
      class="fms-walk-me-close"
      aria-label="Close"
      (click)="closeRequested.emit()"
      [attr.data-fms-heap]="closeHeapId"
    >
      <vng-icon name="close" [outline]="false"></vng-icon>
    </button>
  </div>

  <div class="fms-walk-me-row" style="gap: 10px; margin-top: 10px; padding-left: 20px">
    <vng-progress-bar
      variant="accent"
      mode="determinate"
      [value]="onboardingProgress.percentage"
      class="fms-walk-me-progress-onboarding"
    ></vng-progress-bar>
    {{ onboardingProgress.percentage }}%
  </div>
</header>
<hr class="fms-walk-me-divider" />
<div class="fms-walk-me-row" style="gap: 10px">
  <div class="fms-walk-me-cap-icon">
    <svg-icon-sprite
      width="24px"
      height="28px"
      src="icon-progress-bar"
      vngTooltip="Onboarding"
      vngTooltipPosition="top"
    ></svg-icon-sprite>
  </div>
  <h3 class="fms-walk-me-header-additional">Onboarding</h3>
  <strong>{{ completedCount }}/{{ trackedStepCount }}</strong>
</div>
